import {
  AutoReportProductListResponseType,
  BUSINESS_PAYMENT_PREFIX,
} from '@oy/types';
import axios from 'src/clients/axios';

export const GET_AUTO_REPORT_PRODUCT_LIST_URL = `${BUSINESS_PAYMENT_PREFIX}/auto-report/product/list`;
export const DISABLE_AUTO_REPORT_URL = `${BUSINESS_PAYMENT_PREFIX}/auto-report/disable`;

export const getAutoReportProductList = () => {
  return axios.get<AutoReportProductListResponseType>(
    GET_AUTO_REPORT_PRODUCT_LIST_URL,
  );
};

export const disableAutoReportService = (product_name: string) => {
  return axios.post(DISABLE_AUTO_REPORT_URL, { product_name });
};
